// Generated by ReScript, PLEASE EDIT WITH CARE


var defaultSeoTitleDesc = {
  text: "Pickup drop parcels, courier delivery service from Porter",
  sub_text: "Send packages and get it delivered right at your doorstep. On-demand, hyperlocal online delivery service anywhere in you city. Get a 2 wheeler in 15 mins."
};

export {
  defaultSeoTitleDesc ,
}
/* No side effect */
